/* Styles for form.tsx */

.field > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.375rem;
  margin-bottom: 0;
}

.field__label {
  display: block;
  font-size: 0.6875rem;
  line-height: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgb(var(--fg-muted));
}

.field__text {
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--red-text));
}

.field__text-2 {
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

.form-control {
  height: 2rem;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: rgb(var(--line));
  background-color: rgb(var(--canvas));
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  color: rgb(var(--fg));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.form-control:hover {
  border-color: rgb(var(--line-strong));
}

.form-control:focus-visible {
  border-color: rgb(var(--accent));
}

.form-control:disabled {
  opacity: 0.5;
}

.select {
  padding-right: 1.75rem;
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
}
